import React from 'react';

import Box from '../../components/Box';

const Svg = (props) => {
  return <Box as="svg" {...props} />;
};

export default Svg;
